<template>
    <el-dropdown @command="handleCommand">
        <div class="show_year">
            <span>{{ year }}年</span>
            <el-icon><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item v-for="item in yearList" :key="item" :command="item">{{ item }}年</el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup>
import { computed } from "vue";
import useDateStore from "@/store/modules/useDate";
import { ArrowDown } from "@element-plus/icons-vue";

const dateStore = useDateStore();
const year = computed(() => dateStore.year);
const yearList = computed(() => dateStore.yearList);

// 处理年份点击事件
function handleCommand(command) {
    dateStore.setYear(command);
}
</script>

<style lang="scss" scoped>
.show_year {
    display: flex;
    align-items: center;
    color: #fff;
    cursor: pointer;

    span {
        color: #fff;
        padding-right: 4px;
    }
}
</style>
